import { useEffect } from "react";
import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ModeProvider } from "@/context/ModeContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CookieBanner } from "@/components/CookieBanner";
import Home from "@/pages/Home";

const Opportunities = lazy(() => import("@/pages/Opportunities"));
const OpportunityDetail = lazy(() => import("@/pages/OpportunityDetail"));
const Segnala = lazy(() => import("@/pages/Segnala"));
const ComeFunziona = lazy(() => import("@/pages/ComeFunziona"));
const Aziende = lazy(() => import("@/pages/Aziende"));
const Contatti = lazy(() => import("@/pages/Contatti"));
const Privacy = lazy(() => import("@/pages/Privacy"));
const CookiePolicy = lazy(() => import("@/pages/CookiePolicy"));
const NotFound = lazy(() => import("@/pages/NotFound"));
const AdminApp = lazy(() => import("@/admin/AdminApp"));

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

const Loading = () => <div className="min-h-[60vh]" aria-busy="true" />;

function PublicLayout() {
  return (
    <>
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] btn btn-blue">Vai al contenuto</a>
      <Header />
      <main id="main"><Suspense fallback={<Loading />}><Outlet /></Suspense></main>
      <Footer />
      <CookieBanner />
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <ModeProvider>
        <BrowserRouter>
          <ScrollTop />
          <Routes>
            <Route element={<PublicLayout />}>
              <Route index element={<Home />} />
              <Route path="opportunita" element={<Opportunities />} />
              <Route path="opportunita/:slug" element={<OpportunityDetail />} />
              <Route path="segnala-cosa-cerchi" element={<Segnala />} />
              <Route path="come-funziona" element={<ComeFunziona />} />
              <Route path="per-le-aziende" element={<Aziende />} />
              <Route path="contatti" element={<Contatti />} />
              <Route path="privacy" element={<Privacy />} />
              <Route path="cookie-policy" element={<CookiePolicy />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="admin/*" element={<Suspense fallback={<Loading />}><AdminApp /></Suspense>} />
          </Routes>
          <Toaster position="top-center" theme="dark" richColors />
        </BrowserRouter>
      </ModeProvider>
    </div>
  );
}
